import { triviaQuestionData as questionData } from './data/questionPacks';
import { assertValidTriviaQuestionData } from './triviaQuestionSchema';
import {
  MIXED_CATEGORY_ID,
  shuffleWithSeed,
} from './triviaLogic';

const PUBLIC_QUESTION_DATA = assertValidTriviaQuestionData(questionData);

export function getTriviaCategories(data = PUBLIC_QUESTION_DATA) {
  return data.categories;
}

export function getApprovedQuestions(data = PUBLIC_QUESTION_DATA) {
  return data.questions.filter((question) => question.reviewStatus === 'approved');
}

export function getQuestionsForCategory(data = PUBLIC_QUESTION_DATA, categoryId = MIXED_CATEGORY_ID) {
  const approvedQuestions = getApprovedQuestions(data);

  if (categoryId === MIXED_CATEGORY_ID) {
    return approvedQuestions;
  }

  return approvedQuestions.filter((question) => question.category === categoryId);
}

export function shuffleAnswers(question, seed = question.id) {
  return {
    ...question,
    answers: shuffleWithSeed(question.answers, `${seed}:answers:${question.id}`),
  };
}

export function createTriviaRound({
  data = PUBLIC_QUESTION_DATA,
  categoryId = MIXED_CATEGORY_ID,
  count = 10,
  seed = Date.now(),
} = {}) {
  const eligibleQuestions = getQuestionsForCategory(data, categoryId);
  const shuffledQuestions = shuffleWithSeed(eligibleQuestions, `${seed}:questions:${categoryId}`);
  const selectedQuestions = shuffledQuestions.slice(0, Math.min(count, shuffledQuestions.length));

  return selectedQuestions.map((question, index) => shuffleAnswers(question, `${seed}:${index}`));
}

export { PUBLIC_QUESTION_DATA as triviaQuestionData };
